import { fileManagerContext } from "../../../contexts/fileManager";

export default fileManagerContext.Provider;